module.exports = __webpack_public_path__ + "static/media/downchange.efed3ec9.svg";